import { track as amplitudeTrack } from '@amplitude/analytics-browser';

import { TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { convertPayloadToHumanReadableFieldNames } from '@/utils/amplitude/analytics/utils/convertToHumanReadableFieldNames';

export const isClientSide = () => typeof window !== 'undefined' && typeof document !== 'undefined';
export const isTestRun = typeof jest !== 'undefined';

export const track = (eventName: string, eventPayload: TrackingPayload) => {
    // avoid tracking during SSR and on test runs
    if (isClientSide && !isTestRun) {
        amplitudeTrack(eventName, convertPayloadToHumanReadableFieldNames(eventPayload));
    }
};
